


























import { Component, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { UnifiedInsightsReportsStoreState } from './unified-insights-reports.store';
import { namespace } from 'vuex-class';
import { VuexMappedMutation } from '@sonicwall/unified-ui-framework/src/shared/common-types';

const cssPrefix = 'status-filter';
const reportStoreModule = namespace('UnifiedInsightsReportsStoreModule');

interface FilterOptions {
  label: string;
  id: string;
  statusFlag?: string;
  valueKey: string;
}

@Component({
  components: { SwTextfield, SwCheckbox },
})

export default class StatusFilter extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @reportStoreModule.Mutation
  saveToFilters: VuexMappedMutation<
    UnifiedInsightsReportsStoreState['filterData']
  >;

  @reportStoreModule.State
  filterData: UnifiedInsightsReportsStoreState['filterData'];

  optionsSelected: string[] = [];

  statusOptions: FilterOptions[] = [
    {
      label: this.$t('spog.unifiedInsights.inQueue')
      .toString(),
      id: 'New',
      statusFlag: 'inQueue',
      valueKey: 'inQueue',
    },
    {
      label: this.$t('spog.unifiedInsights.processing')
      .toString(),
      id: 'Processing',
      statusFlag: 'processing',
      valueKey: 'processing',
    },
    {
      label: this.$t('spog.unifiedInsights.ready')
      .toString(),
      id: 'Ready',
      statusFlag: 'ready',
      valueKey: 'ready',
    },
    {
      label: this.$t('home.available')
      .toString(),
      id: 'Available',
      statusFlag: 'available',
      valueKey: 'available',
    },
    {
      label: this.$t('printProductDetails.error')
      .toString(),
      id: 'Error',
      statusFlag: 'error',
      valueKey: 'error',
    },
    {
      label: this.$t('common.success')
      .toString(),
      id: 'Success',
      statusFlag: 'success',
      valueKey: 'success',
    },
    {
      label: this.$t('common.progress')
      .toString(),
      id: 'Progress',
      statusFlag: 'progress',
      valueKey: 'progress',
    },
    {
      label: this.$t('spog.unifiedInsights.partialFail')
      .toString(),
      id: 'PartialFail',
      statusFlag: 'partialFail',
      valueKey: 'partialFail',
    },
    {
      label: this.$t('common.unknown')
      .toString(),
      id: 'Unknown',
      statusFlag: 'unknown',
      valueKey: 'unknown',
    },
  ];

  /*
    @desc returns selected options for Report Status filter.
  */

  get statusFilter() {
    return this.filterData ? this.filterData.status : [];
  }

  @Watch('statusFilter')
  onPropertyChanged(value: string[]) {
    this.optionsSelected = value;
  }

  /*
    @desc updates selected checkbox options.
  */

  updateSelected(event: any) {
    this.optionsSelected = event;
    const obj: any = {
      status: this.optionsSelected,
    };
    this.saveToFilters(obj);
  }

  created() {
    this.optionsSelected = this.statusFilter;
  }
}
